import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import MeetingNavbar from '../../utils/components/meetingScreen/MeetingNavbar'
import MeetingBody from '../../utils/components/meetingScreen/MeetingBody'
import ChatContiner from '../../utils/components/meetingScreen/ChatContiner'
import SearchExercise from '../../utils/components/meetingScreen/SearchExercise'
import { isChrome, isFirefox, isSafari, isMobileSafari, isMobile, withOrientationChange, isMobileOnly } from "react-device-detect";
import swal from 'sweetalert2'
import NewMeetingNavBar from '../../utils/components/meetingScreen/NewDesign/NewMeetingNavBar'
import { useSelector } from 'react-redux'
// import BeforeUnloadComponent from 'react-beforeunload-component';


const MeetingScreen = props => {
    const [ChatBoxOpen, setChatBoxOpen] = useState(false)
    const [Stage, setStage] = useState(1)
    const [SideBarType, setSideBarType] = useState("Chat") //Chat // Actions
    const [ChatSectionType, setChatSectionType] = useState("Chat") //Chat // ROM
    const [MeetingEndDialogOpenForNavbar, setMeetingEndDialogOpenForNavbar] = useState(false)
    const [IsWhiteBoardOpenForNavBar, setIsWhiteBoardOpenForNavBar] = useState(false)
    const [modal, setModal] = useState(false);


    const PatientsList = useSelector(({ meeting }) => meeting.PatientsList)


    const toggle = () => setModal(!modal);

    const { isLandscape, isPortrait } = props


    useEffect(() => {
        if (PatientsList.length == 0) {
            setSideBarType("Chat")
            setChatSectionType("Chat")
            return
        }
    }, [PatientsList])

    useEffect(() => {
        if (isMobileOnly && isLandscape && !ChatBoxOpen) {
            swal.fire({
                cancelButtonText: "Cancel",
                title: "Landscape is not supported please switch to portrait mode!",
                confirmButtonText: "OK",
                showCloseButton: true,
                showCancelButton: false,
            })
        }
    }, [isLandscape])

    useEffect(()=>{
        setChatBoxOpen(false)
    },[MeetingEndDialogOpenForNavbar])

    useEffect(() => {
        if (isPortrait) {
            swal.clickCancel()
        }
    }, [isPortrait])

    return (
        // <div style={{ display: "flex", flexDirection: "row", height: "100vh", width: "100%", overflow: "hidden" }}>

        // <BeforeUnloadComponent
        //     blockRoute={true}
        // >
        <div style={{ display: "flex", flexDirection: "row", height: "100vh", width: "100%", overflow: "hidden", height: "webkit" }}>
            <div style={{ display: "flex", flexDirection: "column", flex: 1 }}>
                {/* <MeetingNavbar
                        openChat={() => setChatBoxOpen(true)}
                    /> */}
                <NewMeetingNavBar
                    IsWhiteBoardOpenForNavBar={IsWhiteBoardOpenForNavBar}
                    MeetingEnded={MeetingEndDialogOpenForNavbar}
                    SideBarType={SideBarType}
                    ChatBoxOpen={ChatBoxOpen}
                    Stage={Stage}
                    openChat={(e) => {
                        setChatBoxOpen(true)
                        setSideBarType("Chat")
                        setChatSectionType(e)
                    }}
                />
                <MeetingBody
                RomStage={Stage}
                    setIsWhiteBoardOpenForNavBar={(e) => setIsWhiteBoardOpenForNavBar(e)}
                    setMeetingEndDialogOpenForNavbar={(e) => setMeetingEndDialogOpenForNavbar(e)}
                    ChatSectionType={ChatSectionType}
                    ChatBoxOpen={ChatBoxOpen}
                    CloseChatBox={(e) => {
                        if (ChatBoxOpen && e == "ROM") {
                            if (SideBarType == "ROM") setChatBoxOpen(!ChatBoxOpen)
                        } else {
                            setChatBoxOpen(!ChatBoxOpen)

                        }

                        setSideBarType(e == "Chat" ? "Chat" : "ROM")
                        setChatSectionType(e)
                    }}
                    CloseChatBoxHARD={() => setChatBoxOpen(false)}
                />
            </div>
            <ChatContiner
                Search={() => setModal(true)}
                ChatBoxOpen={ChatBoxOpen}
                CloseChatBox={() => setChatBoxOpen(!ChatBoxOpen)}
                SideBarType={SideBarType}
                ChatSectionType={ChatSectionType}
                setStage={(e) => setStage(e)}

            />

            {
                modal ? <SearchExercise modal={modal} toggle={toggle} /> : null
            }
        </div>
        // </BeforeUnloadComponent>

    )
}

MeetingScreen.propTypes = {

}

export default withOrientationChange(MeetingScreen)

